import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService, userService } from '../lib/databaseService';
import { toast } from 'sonner';

export default function AuthCallback({ onLogin }) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Supabase auth callback'ini kontrol et
        const session = await authService.getSession();
        
        if (session?.user) {
          const email = session.user.email;
          
          // Kullanıcıyı veritabanında bul veya oluştur
          let user = await userService.findByEmail(email);
          
          if (!user) {
            // Yeni kullanıcı oluştur
            const newUser = {
              name: session.user.user_metadata?.full_name || session.user.email?.split('@')[0] || 'Kullanıcı',
              surname: session.user.user_metadata?.surname || '',
              email: email,
              phone: session.user.phone || '',
              password: '', // Google ile giriş yapanlar için şifre gerekmez
              isAgent: false,
            };
            
            user = await userService.register(newUser);
          }

          // Kullanıcıyı giriş yap
          const userData = {
            id: user.id,
            name: user.name,
            surname: user.surname || '',
            email: user.email,
            phone: user.phone || '',
            agencyId: user.agency_id,
            isAgent: user.is_agent || false,
          };

          onLogin(userData);
          toast.success(`Xoş gəldiniz, ${user.name}!`);
          navigate('/');
        } else {
          toast.error('Giriş uğursuz oldu');
          navigate('/agencies');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Giriş zamanı xəta baş verdi');
        navigate('/agencies');
      }
    };

    handleAuthCallback();
  }, [navigate, onLogin]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#B91C1C] mx-auto mb-4"></div>
        <p className="text-gray-600">Giriş edilir...</p>
      </div>
    </div>
  );
}

